import React from 'react'

const IconCompareStatus = ({title, card1, card2}) => {
  return (
    <div className="flex  justify-center border-b-[1px]">
        <div className="text-[#5C5A5A] md:text-[24px] border-r-[1px] w-[40%] border-[#D9D9D9] justify-center p-4 font-montserrat flex-none pr-3 pl-4">
          {title}
        </div>
        <div className=" text-[#5C5A5A] font-medium font-montserrat flex border-r-[1px] border-[#D9D9D9] place-content-center px-3 py-4 flex-1 w-[30%]">
          <img src={card1} alt="" className="h-16 w-16 object-contain" />
        </div>
        <div className="justify-center object-cover text-[#5C5A5A] font-medium font-montserrat flex px-4 py-4 flex-1 place-content-center w-[30%]">
          <img src={card2} alt="" className="h-16 object-contain" />
        </div>
      </div>
  )
}

export default IconCompareStatus